/**
 * OFFLINE-DISTRIBUTION-PLAN.md §3.5 — the weekly check-in lock's two
 * banners, ported from ../lims/apps/web/src/app/LicenseLockBanner.tsx:
 *   - yellow warning for every user from `graceDays - 3` days out
 *     (`staleWarningMessage`), while the install is still writable;
 *   - red lock with the fixed `LOCK_MESSAGES` copy once `lockState` is
 *     STALE / MISMATCH / VERSION (the API has already collapsed every
 *     permission to view-only by then — `middleware/rbac.ts`).
 * Both read the session the API hands back (`SessionUser.lockState` /
 * `daysUntilLock`), so no extra request.
 */
import { AlertTriangle, Lock } from 'lucide-react';
import { LOCK_MESSAGES, staleWarningMessage } from '@pospak/shared';
import { useAuth } from '../stores/auth';

const STALE_WARNING_DAYS = 3;

export function LicenseLockBanner() {
  const lockState = useAuth((s) => s.user?.lockState ?? 'NONE');
  const daysUntilLock = useAuth((s) => s.user?.daysUntilLock ?? null);

  if (lockState !== 'NONE') {
    return (
      <div role="alert" className="flex items-center justify-center gap-2 bg-danger px-4 py-2 text-center text-sm text-white">
        <Lock size={16} aria-hidden />
        {LOCK_MESSAGES[lockState]}
      </div>
    );
  }

  if (daysUntilLock !== null && daysUntilLock <= STALE_WARNING_DAYS) {
    return (
      <div role="status" className="flex items-center justify-center gap-2 bg-warn px-4 py-2 text-center text-sm text-white">
        <AlertTriangle size={16} aria-hidden />
        {staleWarningMessage(daysUntilLock)}
      </div>
    );
  }

  return null;
}
